import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, ArrowLeft, Landmark } from 'lucide-react';
import { ASSETS } from '../../mock/data';
import { useApp } from '../../context/AppContext';

const HOLogin = () => {
  const nav = useNavigate();
  const { login } = useApp();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const u = await login({ email, password });
      if (u.role !== 'chief_accountant' && u.role !== 'admin') {
        setErr('This account is not a Chief Accountant. Please use the correct workspace login.');
        return;
      }
      nav('/ho');
    } catch (ex) {
      setErr(ex.response?.data?.detail || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-100 flex items-center justify-center px-5" data-testid="ho-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="px-6 pt-6">
          <button onClick={() => nav('/')} data-testid="ho-login-back" className="text-sm text-neutral-500 hover:text-neutral-900 inline-flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Back to site
          </button>
        </div>
        <div className="px-6 pt-4 pb-8">
          <div className="bg-[#4338CA] rounded-xl p-4 inline-flex items-center gap-3">
            <div className="bg-white rounded p-1"><img src={ASSETS.logo} className="h-10" alt="Clean24" /></div>
            <div>
              <p className="text-white font-bold text-sm">Clean24 Head Office</p>
              <p className="text-indigo-100 text-xs">Chief Accountant · Group consolidation & approvals</p>
            </div>
          </div>

          <h1 className="mt-5 text-2xl font-extrabold text-neutral-900">Head Office login</h1>
          <p className="text-sm text-neutral-500 mt-1">Consolidated Group Dashboard · HO expenses · Approval queues.</p>

          {err && <div className="mt-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg" data-testid="ho-login-error">{err}</div>}

          <form onSubmit={submit} className="mt-5 space-y-3">
            <div className="relative">
              <Mail className="w-4 h-4 text-neutral-400 absolute left-4 top-1/2 -translate-y-1/2" />
              <input type="email" required placeholder="ca@clean24.com" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="ho-login-email"
                className="w-full pl-11 pr-4 py-3 rounded-xl border border-neutral-200 bg-white focus:outline-none focus:border-[#4338CA] focus:ring-2 focus:ring-[#4338CA]/20 text-sm" />
            </div>
            <div className="relative">
              <Lock className="w-4 h-4 text-neutral-400 absolute left-4 top-1/2 -translate-y-1/2" />
              <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="ho-login-password"
                className="w-full pl-11 pr-4 py-3 rounded-xl border border-neutral-200 bg-white focus:outline-none focus:border-[#4338CA] focus:ring-2 focus:ring-[#4338CA]/20 text-sm" />
            </div>
            <button type="submit" disabled={loading} data-testid="ho-login-submit"
              className="w-full py-3 rounded-xl bg-[#4338CA] hover:bg-[#3730A3] disabled:opacity-70 text-white font-semibold">
              {loading ? 'Signing in…' : 'Sign in as Chief Accountant'}
            </button>
          </form>

          <div className="mt-4 p-3 bg-indigo-50 border border-indigo-100 rounded-lg text-xs text-indigo-900">
            <p className="font-semibold flex items-center gap-1"><Landmark className="w-3.5 h-3.5" /> Need an account?</p>
            <p className="mt-1">Only Super Admin can create Chief Accountant credentials. Contact them at admin@clean24.com.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HOLogin;
